import React, { useEffect, useMemo, useState } from 'react'
import { MAX_ATTEMPTS, tokenizeWord } from './HelpersFunctions'
import TokenGlyph from './TokenGlyph'
import './ResultOverlay.css'
import { FiShare2 } from 'react-icons/fi';

/* 🟩 olive correct, 🟨 saffron present, ⬛ stone absent — matches v1 palette */
const STATE_EMOJI = { correct: '🟩', present: '🟨', absent: '⬛' }

const WODU_START = Date.UTC(2026, 4, 9) // May 9 2026, day 1

function buildShareText(won, attemptCount, answerDictionaryState) {
  const dayNumber = Math.floor((Date.now() - WODU_START) / 86400000) + 1
  const result = won ? `${attemptCount}/${MAX_ATTEMPTS}` : 'X/6'
  const grid = Object.values(answerDictionaryState)
    .filter(Boolean)
    .map(row => row.map(s => STATE_EMOJI[s] ?? '⬛').join(''))
    .join('\n')
  return `Wọ́dù day ${dayNumber} \n\nAttempt ${result}\n${grid}`
}

const ResultOverlay = ({ won, answerDictionaryState, word, attemptCount, onClose }) => {
  const [copied, setCopied] = useState(false)
  const wordTokens = useMemo(() => tokenizeWord(word), [word])

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const handleShare = () => {
    const text = buildShareText(won, attemptCount, answerDictionaryState)
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="result-overlay" onClick={onClose}>
      <div className="result-overlay__card" onClick={e => e.stopPropagation()}>
        <button className="result-overlay__close" onClick={onClose} aria-label="Close">×</button>

        <p className="result-overlay__eyebrow">
          {won ? 'Ó yá! You got it' : 'Ó burú. Better luck tomorrow'}
        </p>

        <p className="result-overlay__word">
          {wordTokens.map((token, index) => (
            <TokenGlyph key={`${token}-${index}`} token={token} />
          ))}
        </p>

        {won && (
          <p className="result-overlay__stat">
            Solved in <strong>{attemptCount}</strong> of {MAX_ATTEMPTS} guesses
          </p>
        )}

        {!won && (
          <p className="result-overlay__stat">The word was above. Come back tomorrow.</p>
        )}

        <button className="result-overlay__share" onClick={handleShare}>
          {copied ? (
            'Copied!'
          ) : (
            <>
              <FiShare2 className="result-overlay__share-icon" aria-hidden="true" />
              <span>Share result</span>
            </>
          )}
        </button>
      </div>
    </div>
  )
}

export default ResultOverlay
